module.exports = "<xo-generic-message token=token></xo-generic-message>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/noop-loader!./pages/xo-generic-message/template.html
// module id = ../node_modules/noop-loader/index.js!./pages/xo-generic-message/template.html
// module chunks = 0